<template>
  <v-card flat class="outline">
    <!-- Fallback contents -->
    <v-card-text v-for="(item, key) in items" :key="key" class="pa-2">
      <!-- Render: info -->
      <checklist-info
        v-if="(/info/).test(item.type)"
        :level="item.lvl"
        :index="item.idx"
        :label="item.label"
        :description="item.description"
        :translation="item.translation || {}"
      ></checklist-info>
      <!-- Render: image -->
      <checklist-image
        v-if="(/image/).test(item.type)"
        :level="item.lvl"
        :index="item.idx"
        :label="item.label"
        :description="item.description"
        :translation="item.translation || {}"
        :items="item.items"
      ></checklist-image>
      <!-- Render: section -->
      <checklist-section
        v-if="(/section/).test(item.type)"
        :level="item.lvl"
        :index="item.idx"
        :label="item.label"
        :description="item.description"
        :translation="item.translation || {}"
        :items="item.items"
      ></checklist-section>
      <!-- Render: input -->
      <checklist-input
        v-if="(/switch|number|string|file/).test(item.type)"
        :level="item.lvl"
        :index="item.idx"
        :label="item.label"
        :description="item.description"
        :translation="item.translation || {}"
        :validations="item.validations"
        :items="item.items"
        :type="item.type"
        :source="item.source"
      ></checklist-input>
    </v-card-text>
  </v-card>
</template>

<style>
  .outline {
    border: 1px solid #eee !important;
    border-radius: 2px;
  }
</style>

<script>
import ChecklistSection from './checklist-section.vue'
import ChecklistInfo from './checklist-info.vue'
import ChecklistImage from './checklist-image.vue'

export default {
  name: 'checklist-fallback',
  props: {
    level: Number,
    index: Number,
    items: Array
  },
  components: {
    ChecklistSection,
    ChecklistInfo,
    ChecklistImage,
    ChecklistInput: () => import('./checklist-input.vue') // webpack async import (fix circular reference)
  }
}
</script>
